import { cloneDeep, isNil } from 'lodash';
import { ReactNode } from 'react';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { SupportedSubformComponentValue } from '@shared/components/blocks/types';
import { WorkflowView } from '@shared/scenes/workflows/views/view-components/WorkflowView';
import { BaseSubformRoute, MBNavStackProvider, useNavStackContext } from '@shared/util/navigation';

interface CardFormSubformContainerProps {
  children: ReactNode;
}

const initialRoute: BaseSubformRoute = { name: 'cardForm' };
const initialRoutes = [initialRoute];

export function CardFormSubformContainer(props: CardFormSubformContainerProps) {
  return (
    <MBNavStackProvider<BaseSubformRoute> initialRoutes={initialRoutes}>
      <ConditionalNav {...props} />
    </MBNavStackProvider>
  );
}

function ConditionalNav(props: CardFormSubformContainerProps) {
  const navContext = useNavStackContext<BaseSubformRoute>();
  const cardContext = useCardFormContext();
  const { currentRoute } = navContext;

  if (currentRoute?.name === 'subform' && currentRoute.params) {
    const { workflowTemplateId, parentComponentId } = currentRoute.params;
    const initialData = isNil(cardContext.values[parentComponentId]?.data)
      ? {}
      : cloneDeep(cardContext.values[parentComponentId].data);

    const onSubmit = (data: Record<string, SupportedSubformComponentValue>) => {
      cardContext.setFieldValue(parentComponentId, {
        workflowTemplateId,
        data,
      });
      navContext.pop();
    };

    return (
      <WorkflowView
        workflowTemplateId={workflowTemplateId}
        initialData={initialData}
        onSubmit={onSubmit}
      />
    );
  }
  return <>{props.children}</>;
}
